import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _isNumber from 'lodash/isNumber';
import _startswith from 'lodash/startsWith';
import queryString from 'query-string';

import { UserDetailsContext } from 'context/userDetails';
import { AppContext } from 'commons-ui';

import useService from './useService';

const useSelectUser = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { setUserSearchDetails, setSelectedUser } = useContext(UserDetailsContext);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const { getUserData } = useService();

	const handleFormSubmit = async (selectedUser: any) => {
		if (_isEmpty(selectedUser)) {
			showAlert('Atleast one of the fields is required', { type: 'error' });
		} else {
			setShowLoader(true);
			let selectionType: string = '';
			let selectedValue: string | number = '';
			const { email, uid, phone } = selectedUser;
			if (!_isNil(uid) && _isNumber(uid)) {
				selectionType = 'uid';
				selectedValue = uid;
			} else if (!_isNil(phone) && !_isEmpty(phone)) {
				selectionType = 'phone';
				selectedValue = _startswith(phone, '+91') ? phone : `+91${phone}`;
			} else if (!_isNil(email) && !_isEmpty(email)) {
				selectionType = 'email';
				selectedValue = email;
			}
			if (_isEmpty(selectionType) || (!_isNumber(selectedValue) && _isEmpty(selectedValue))) {
				showAlert('Atleast one of the fields is required', { type: 'error' });
				setShowLoader(false);
			} else {
				try {
					const userDetails = await getUserData(selectionType, selectedValue);
					setUserSearchDetails({ selectionType, selectedValue });
					setSelectedUser(userDetails);
					setShowLoader(false);
					history.push({
						pathname: '/userProfile/home',
						search: `?${queryString.stringify({ [selectionType || '']: selectedValue })}`
					});
				} catch (error: any) {
					showAlert(error.error || 'User not found', { type: 'error' });
					setShowLoader(false);
				}
			}
		}
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { showLoader, setShowLoader, handleFormCancel, handleFormSubmit };
};

export default useSelectUser;
